import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OfferedService } from '@prisma/client';
import { OfferedServiceResourceTypeMappings } from '@aa/nest/resource';
import { offeredServiceCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class OfferedServiceService extends BaseResourceService<OfferedServiceResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'offered-services');
  }
}
